
import  {getFixedLineSOHOCustomerInfofromApi ,getSOHOServicesFromApi} from '../../api/fixedLineSOHOCustomerInfo/index'
import { 
    SET_SOHO_CUSTOMER_INFO,
    FAILED_SET_SOHO_CUSTOMER_INFO,
    SET_SOHO_SERVICES
  } from './actionsTypes'

export const getFixedLineSOHOCustomerInfo = async (dispatch) => {
    dispatch(setSOHOCustomerInfo({ isLoading: true }))
    const res = await getFixedLineSOHOCustomerInfofromApi()
    dispatch(setSOHOCustomerInfo({ ...res.data, loaded: true }))
    if (res.error) {
      dispatch(SOHOCustomerInfoFailed(res.error))
    }
  }

export const getFixedLineSOHOServices = async (dispatch) => {
    dispatch(setSOHOServices({ isLoading: true }))
    const res = await getSOHOServicesFromApi()
    dispatch(setSOHOServices(res))
}


  export const setSOHOCustomerInfo = (CustomerInfo) => ({
    type: SET_SOHO_CUSTOMER_INFO,
    payload: CustomerInfo,
  })
  
  export const SOHOCustomerInfoFailed = (error) => ({
    type: FAILED_SET_SOHO_CUSTOMER_INFO,
    payload: error,
  })

  export const setSOHOServices = (activeServiceInfo) => ({
    type: SET_SOHO_SERVICES,
    payload: activeServiceInfo,
  })


